<template>
  <div class="mc-container">
    <div class="mc-tabs__button-wrapper">
      <ul class="mc-tabs__list mc-tabs__list-gender">
        <li @click="setGender('woman')" class="mc-tabs__item" :class="{isActive:gender=='woman'}" id="tab1"><button class="mc-tabs__button js-button-tab" data-name="content1" type="button">Женское</button></li>
        <li @click="setGender('man')" class="mc-tabs__item" :class="{isActive:gender=='man'}" id="tab2"><button class="mc-tabs__button js-button-tab" data-name="content2" type="button">Мужское</button></li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  computed: {
    ...mapGetters([
      'gender',
      'genderLoading',
      'genderError',
      'genderLoaded'
    ])
  },
  mounted() {

  },
  created() {
    this.fetchGender();
  },
  components: {},
  methods: {
    ...mapActions([
      'fetchGender',
      'setGender',
    ]),
  },
}
</script>